import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Subject from '../../components/Subject';
import PageHeader from '../../components/PageHeader';
import './styles/learningSpace.scss'
import { ApiHelper } from '../../apiHelper/ApiHelper';
import { readJson } from '../../apiHelper/readJson';

export default function LearningSpace() {
    const [progress, setProgress] = useState({ physicsProgress: 0, biologyProgress: 0, chemistryProgress: 0 });
    const [fetched, setFetched] = useState(false);
    const navigate = useNavigate();

    const api = new ApiHelper();

    async function fetch() {
        try {
            const res = await api.lessonsApi.getProgressList();
            setProgress(await readJson(res));
        } catch (x: any) {
            api.processErrors(x);
        }
    }

    useEffect(() => {
        if (!fetched) {
            fetch();
            setFetched(true);
        }
    }, []);

    return (
        <div className="materials">
            <PageHeader title="Studijní materiály" subtitle="Vyber si předmět a pokračuj ve studiu" />

            <div className="subjectGrid">
                <Subject onClick={() => navigate("/kurz/materialy/fyzika")} title="Fyzika" img="/images/components/atom.png" progress={progress.physicsProgress} />
                <Subject onClick={() => navigate("/kurz/materialy/chemie")} title="Chemie" img="/images/components/isopropanol.png" progress={progress.chemistryProgress} />
                <Subject onClick={() => navigate("/kurz/materialy/biologie")} title="Biologie" img="/images/components/cell.png" progress={progress.biologyProgress} />
            </div>
        </div>
    );
}
